import React, { useEffect, useState } from "react";
import styles from "./CaseStudies.module.css";
import { API_BASE_URL } from "configs/AppConfig";
import CaseStudiesCard from "./CaseStudiesCard";
import RecentPosts from "../reviewsAndBlogs/recent-posts/RecentPosts";
import Loader from "../common-component/Loader/Loader";
import MetaDetails from "components/meta-details/MetaDetails";
import SEO from "components/SEO/SEO";

function CaseStudies() {
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState({success1: false, success2: false})

  const fetchData = async () => {
    const response = await fetch(
      `${API_BASE_URL}pages/get/all?category=670f4ed8c258c9679a93f38b`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    if(data?.success){
        setSuccess((prev)=>({...prev,success1: true}))
    }
    setList(data?.data?.sort((a, b) => a.priority - b.priority));
    console.log("data pages", data);

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  const fetchRecentPosts = async () => {
    const response = await fetch(
      `${API_BASE_URL}pages/get/all?category=6708c38c5e9b4984e1e2212e`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    if(data?.success){
        setSuccess((prev)=>({...prev,success2: true}))
    }
    setData(data?.data?.sort((a, b) => a.priority - b.priority));
    console.log("data pages", data);

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  useEffect(()=>{
if(success.success1 && success.success2){
    setLoading(false);
}
  },[success])

  useEffect(() => {
    fetchData();
    fetchRecentPosts();
  }, []);

  return (
    <>
     <SEO />
    <MetaDetails
        title={"Case Studies"}
        description={"Case Studies"}
        keywords={["case studies"]?.join(', ')}
      />
    {loading ? <Loader /> : (
    <div className={styles.caseOuter}>
      <div className={styles.bannerDiv}>
        <img
          className={styles.bannerImage}
          src="/img/bodyshop/performance-slide-two.png"
        />
        <div className={styles.contentDiv}>
          <h1>PROJECTS</h1>
          <img src="/img/bodyshop/down-arrow.svg" />
        </div>
      </div>
      <div className={styles.caseStudiesList}>
        <div className={styles.leftDiv}>
          {list?.map((item) => (
            <CaseStudiesCard item={item} />
          ))}
        </div>
        <div className={styles.rightDiv}>
          <RecentPosts
            list={data}
            background="#EEE"
            searchColor="#0096ff"
            textColor="#000814"
          />
        </div>
      </div>
    </div>
    )}
    </>
  );
}

export default CaseStudies;
